"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  border-radius: 4px;\n  margin: 12px 0 20px;\n  color: ", ";\n  font-family: ", ";\n  ", ";\n  width: ", ";\n"], ["\n  position: relative;\n  display: flex;\n  border-radius: 4px;\n  margin: 12px 0 20px;\n  color: ", ";\n  font-family: ", ";\n  ", ";\n  width: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  overflow-y: auto;\n  width: 100%;\n  z-index: 0;\n"], ["\n  position: relative;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  overflow-y: auto;\n  width: 100%;\n  z-index: 0;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 10px 16px;\n  background: ", ";\n  color: ", ";\n  text-align: left;\n  border: none;\n  &:not(:last-child) {\n    border-bottom: 1px solid ", ";\n  }\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:focus {\n    background: ", ";\n    color: ", ";\n    outline: none;\n  }\n\n  em {\n    font-style: normal;\n    font-weight: ", ";\n  }\n"], ["\n  width: 100%;\n  padding: 10px 16px;\n  background: ", ";\n  color: ", ";\n  text-align: left;\n  border: none;\n  &:not(:last-child) {\n    border-bottom: 1px solid ", ";\n  }\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:focus {\n    background: ", ";\n    color: ", ";\n    outline: none;\n  }\n\n  em {\n    font-style: normal;\n    font-weight: ", ";\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  line-height: 1.25;\n  color: inherit;\n  em {\n    font-weight: ", ";\n  }\n"], ["\n  line-height: 1.25;\n  color: inherit;\n  em {\n    font-weight: ", ";\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0;\n  z-index: 1;\n  outline: none;\n  box-shadow: ", ";\n  font-weight: ", ";\n  background: ", ";\n  ", ";\n  border: none;\n  color: ", ";\n  caret-color: ", ";\n  padding-right: 40px;\n  text-overflow: ellipsis;\n  height: 48px;\n\n  &:focus {\n    box-shadow: ", ";\n    outline: 5px auto #0042CB;\n    border: none;\n  }\n\n  &::placeholder {\n    opacity: 1;\n    color: ", ";\n  }\n\n  &:-ms-input-placeholder { /* IE 10+ */\n    opacity: 1;\n    color: ", ";\n  }\n"], ["\n  position: relative;\n  margin: 0;\n  z-index: 1;\n  outline: none;\n  box-shadow: ", ";\n  font-weight: ", ";\n  background: ", ";\n  ", ";\n  border: none;\n  color: ", ";\n  caret-color: ", ";\n  padding-right: 40px;\n  text-overflow: ellipsis;\n  height: 48px;\n\n  &:focus {\n    box-shadow: ", ";\n    outline: 5px auto #0042CB;\n    border: none;\n  }\n\n  &::placeholder {\n    opacity: 1;\n    color: ", ";\n  }\n\n  &:-ms-input-placeholder { /* IE 10+ */\n    opacity: 1;\n    color: ", ";\n  }\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  top: 4px;\n  right: ", ";\n"], ["\n  top: 4px;\n  right: ", ";\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  top: 4px;\n  padding: 11px;\n  right: ", ";\n"], ["\n  top: 4px;\n  padding: 11px;\n  right: ", ";\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  margin: 40px 0 12px 16px;\n  font-weight: ", ";\n"], ["\n  margin: 40px 0 12px 16px;\n  font-weight: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _buoyInput = require("buoy-input");

var _buoyInput2 = _interopRequireDefault(_buoyInput);

var _buoyText = require("buoy-text");

var _buoyTheme = require("buoy-theme");

var _searchIcon = require("./images/searchIcon");

var _searchIcon2 = _interopRequireDefault(_searchIcon);

var _buoyCloseIcon = require("buoy-close-icon");

var _buoyCloseIcon2 = _interopRequireDefault(_buoyCloseIcon);

var _http = require("./utils/http");

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.form.withConfig({
  displayName: "src__Wrapper",
  componentId: "mtxix6-0"
})(_templateObject, _buoyTheme.colors.neutralDarkest, _buoyTheme.fontFamily, (0, _buoyTheme.fontSize)("bodyMain"), function (props) {
  return props.width ? props.width : "100%";
});

var SuggestionList = _styledComponents2.default.div.withConfig({
  displayName: "src__SuggestionList",
  componentId: "mtxix6-1"
})(_templateObject2);

var Suggestion = _styledComponents2.default.button.withConfig({
  displayName: "src__Suggestion",
  componentId: "mtxix6-2"
})(_templateObject3, function (props) {
  return props.active ? _buoyTheme.colors.primary : _buoyTheme.colors.white;
}, function (props) {
  return props.active ? _buoyTheme.colors.white : _buoyTheme.colors.primary;
}, _buoyTheme.colors.neutralLightest, _buoyTheme.colors.primary, _buoyTheme.colors.white, _buoyTheme.colors.primary, _buoyTheme.colors.white, _buoyTheme.fontWeight.medium);

var Text = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: "src__Text",
  componentId: "mtxix6-3"
})(_templateObject4, _buoyTheme.fontWeight.medium);

var boxShadow = 'rgba(0, 0, 0, 0.2) 0 0 16px 0';
var focusBoxShadow = 'rgba(0, 0, 0, 0.24) 0 0 12px 0';

var StyledFormInput = (0, _styledComponents2.default)(_buoyInput2.default).withConfig({
  displayName: "src__StyledFormInput",
  componentId: "mtxix6-4"
})(_templateObject5, boxShadow, _buoyTheme.fontWeight.light, _buoyTheme.colors.white, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.colors.neutralDarkest, _buoyTheme.colors.primary, focusBoxShadow, _buoyTheme.colors.neutral, _buoyTheme.colors.neutral);

// Given autocomplete suggestion and search query,
// returns formatted string with text following query in bold
var boldAutocomplete = function boldAutocomplete(suggestion, query) {
  if (suggestion.toLowerCase().indexOf(query.toLowerCase()) === 0) {
    var qlen = query.length;
    return _react2.default.createElement(
      "span",
      null,
      " ",
      suggestion.substr(0, qlen),
      _react2.default.createElement(
        "em",
        null,
        suggestion.substr(qlen)
      ),
      " "
    );
  }
  return suggestion;
};

var CloseButton = (0, _styledComponents2.default)(_buoyCloseIcon2.default).attrs({
  color: _buoyTheme.colors.primary,
  padding: "11px",
  hoverColor: "primaryLightest",
  size: "40px",
  iconSize: "18px",
  backgroundSize: "45px"
}).withConfig({
  displayName: "src__CloseButton",
  componentId: "mtxix6-5"
})(_templateObject6, function (props) {
  return props.right;
});

var SearchIcon = (0, _styledComponents2.default)(_searchIcon2.default).withConfig({
  displayName: "src__SearchIcon",
  componentId: "mtxix6-6"
})(_templateObject7, function (props) {
  return props.right;
});

var SuggestionHeader = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: "src__SuggestionHeader",
  componentId: "mtxix6-7"
})(_templateObject8, _buoyTheme.fontWeight.medium);

var AutoSuggest = function AutoSuggest(props) {
  /**
   * AutoSuggest is a component which provides users a list of options
   * to choose from based on what they've typed.
   *
   * This is a "dumb" component which simply renders an input field
   * with suggestions based on props.
   */

  var placeholder = props.placeholder,
      value = props.value,
      onChange = props.onChange,
      onClear = props.onClear,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onClearMouseDown = props.onClearMouseDown,
      onSuggestionMouseDown = props.onSuggestionMouseDown,
      suggestionClick = props.suggestionClick,
      suggestions = props.suggestions,
      activeSuggestion = props.activeSuggestion,
      setListRef = props.setListRef,
      setInputRef = props.setInputRef,
      setSuggestionRef = props.setSuggestionRef,
      focused = props.focused,
      showCancel = props.showCancel,
      onCancel = props.onCancel,
      showDefaults = props.showDefaults,
      suggestionHeader = props.suggestionHeader,
      showSuggestionHeader = props.showSuggestionHeader;


  var showSuggestions = value.length > 0 || value.length === 0 && showDefaults;

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      Wrapper,
      { action: "" },
      _react2.default.createElement(StyledFormInput, {
        type: "text",
        id: "search-input",
        "aria-label": "Search input",
        autoComplete: "off",
        placeholder: placeholder,
        value: value,
        valid: true,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        innerRef: setInputRef
      }),
      value.length > 0 ? _react2.default.createElement(CloseButton, {
        onClick: onClear,
        onMouseDown: onClearMouseDown,
        tabIndex: 0,
        "aria-label": "Clear search",
        right: showCancel ? "54px" : "5px" }) : _react2.default.createElement(SearchIcon, { focused: focused, right: showCancel ? "54px" : "5px" }),
      showCancel && _react2.default.createElement(
        _buoyText.ButtonLink,
        {
          weight: "light",
          fontSize: "bodySmall",
          color: "neutral",
          margin: "auto 0 auto 12px",
          tabIndex: 0,
          "aria-label": "Cancel search",
          onClick: onCancel },
        "Cancel"
      )
    ),
    showSuggestionHeader && _react2.default.createElement(
      SuggestionHeader,
      null,
      suggestionHeader
    ),
    showSuggestions && suggestions.length > 0 && _react2.default.createElement(
      SuggestionList,
      { "aria-label": "Search suggestions", innerRef: setListRef },
      suggestions.map(function (s, i) {
        return _react2.default.createElement(
          Suggestion,
          {
            key: i,
            tabIndex: 0,
            role: "text",
            active: activeSuggestion === i,
            onMouseDown: function onMouseDown(e) {
              return onSuggestionMouseDown(e, s.text);
            },
            onClick: function onClick() {
              return suggestionClick(s.text);
            },
            innerRef: setSuggestionRef(i)
          },
          _react2.default.createElement(
            Text,
            { margin: "0", color: "primary" },
            showSuggestionHeader ? s.text : boldAutocomplete(s.text, value)
          )
        );
      })
    )
  );
};

AutoSuggest.propTypes = {
  value: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  suggestions: _propTypes2.default.array,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onClear: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  onClearMouseDown: _propTypes2.default.func,
  onSuggestionMouseDown: _propTypes2.default.func,
  suggestionClick: _propTypes2.default.func,
  activeSuggestion: _propTypes2.default.number,
  setListRef: _propTypes2.default.func,
  setInputRef: _propTypes2.default.func,
  setSuggestionRef: _propTypes2.default.func,
  showCancel: _propTypes2.default.bool,
  showDefaults: _propTypes2.default.bool,
  suggestionHeader: _propTypes2.default.string,
  showSuggestionHeader: _propTypes2.default.bool
};

AutoSuggest.defaultProps = {
  onClear: function onClear() {},
  onClearMouseDown: function onClearMouseDown() {},
  suggestionClick: function suggestionClick() {},
  onSuggestionMouseDown: function onSuggestionMouseDown() {},
  suggestions: [],
  showCancel: false,
  showDefaults: false,
  suggestionHeader: '',
  showSuggestionHeader: false
};

exports.default = AutoSuggest;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-autosuggest/dist/index.js
// module id = 389
// module chunks = 168707334958949